import React, { useEffect } from 'react';

export const MARKETING_CONSENT_GRANTED_EVENT = 'marketing-consent-granted';
export const MARKETING_CONSENT_REVOKED_EVENT = 'marketing-consent-revoked';

const PIXEL_ID = '1650697026165861';

function loadMetaPixel() {
  if (window.fbq) return;

  const n: any = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  window.fbq = n;
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode!.insertBefore(script, firstScript);

  window.fbq('init', PIXEL_ID);
  window.fbq('track', 'PageView');
}

export const MetaPixel: React.FC = () => {
  useEffect(() => {
    const handleGranted = () => loadMetaPixel();
    const handleRevoked = () => {
      if (window.fbq) {
        window.fbq('consent', 'revoke');
      }
    };

    window.addEventListener(MARKETING_CONSENT_GRANTED_EVENT, handleGranted);
    window.addEventListener(MARKETING_CONSENT_REVOKED_EVENT, handleRevoked);

    if (window.CC && window.CC.allowedCategory('marketing')) {
      loadMetaPixel();
    }

    return () => {
      window.removeEventListener(MARKETING_CONSENT_GRANTED_EVENT, handleGranted);
      window.removeEventListener(MARKETING_CONSENT_REVOKED_EVENT, handleRevoked);
    };
  }, []);

  return null;
};
